import { KeyValuePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from '../loginmodule/login.module';
import { SpinnerService } from './ncs/services/spinner.service';
import { NGXToastrService } from './shared/services/toastr.service';
import { ToastrModule } from 'ngx-toastr';
import { LoginService } from './ncs/services/login.service';
import { HttpClientModule, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HCPService } from './ncs/services/hcp.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserActivationService } from './ncs/services/useractivation.service';
import { ActorService } from './ncs/services/actor.service';
import { MasterService } from './ncs/services/master.service';
import { TestnurseModule } from './ncs/modules/testnurse/testnurse.module';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService, TranslateStore, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomDateTimeService } from './ncs/services/datetime.service';
import { FDService } from './ncs/services/fd.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgxPrintModule } from 'ngx-print';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrintService } from './ncs/services/print.service';
import { PrintingModule } from './ncs/modules/printing/printing.module';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { QRCodeModule } from 'angularx-qrcode';
import { PrintIDLService } from './ncs/services/printIDL.service';
import { CustomerAppSettingsReader } from './ncs/models/CustomerAppSettingsReader';

import { provideNgxMask } from 'ngx-mask';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgxPrintModule,
    NoopAnimationsModule,
    AppRoutingModule,
    LoginModule,
    TestnurseModule,
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    PrintingModule,
    QRCodeModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    FormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxMaterialTimepickerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ReactiveFormsModule
  ],
  providers: [
    provideNgxMask(),
    KeyValuePipe,
    SpinnerService,
    NGXToastrService,
    TranslateModule,
    HCPService,
    UserActivationService,
    FDService,
    ActorService,
    MasterService,
    TranslateService,
    CustomDateTimeService,
    TranslateStore,
    CustomerAppSettingsReader,
    PrintService,
    PrintIDLService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
